import * as header from '@grupa-pracuj/header';
import '@grupa-pracuj/header/dist/styles.css';

import { SERVICE_NAME, API_TRANSLATIONS } from 'config';
import createHttp from 'src/api/http';
import captureException from 'src/api/sentry';
import { bootstrapClient } from 'src/bootstrap';
import env from 'src/common/enviroment';


const bottomMenuActiveItemStrategies = new Map([
  ['offer-page', 'none'],
  ['home-page', 'homepage'],
  ['default', 'none']
]);

const bootstrapApplication = () => {
  const container = document.querySelector(`[data-application-name="${SERVICE_NAME}"]`);

  const { dataset: { fragmentHost } } = container;

  import('src/links')
    .then(({ links }) => {
      const mobileLayoutStrategies = new Map([
        ['offer-page',
          () => {
            const previousNavigationLink = document.referrer || links.LINK_JOB_OFFERS;
            return header.createBackTitleSearchLayout({
              previousNavigationLink,
              title: 'Oferta pracy'
            });
          }],
        ['home-page', header.createStandardLayout],
        ['default', header.createStandardLayout]
      ]);

      return header.attach({
        container,
        navigation: header.getNavigation(links),
        user: header.getUserFromCookie(),
        isUnsupportedBrowser: !env.isSupportedBrowser,
        translationsEndpoint: API_TRANSLATIONS,
        http: createHttp(),
        bottomMenuConfig: {
          activeItem: bottomMenuActiveItemStrategies.get(fragmentHost),
          displayBottomMenu: true
        },
        customizationConfig: {
          shouldDisplayCookiePolicy: false,
          desktopLayout: header.createStandardLayout,
          mobileLayout: mobileLayoutStrategies.get(fragmentHost)
        },
      });
    })
    .catch((error) => {
      captureException(error);
    });
};

document.addEventListener('application::ready', bootstrapClient(bootstrapApplication));

if (module.hot) {
  module.hot.accept();
}
